document.documentElement.classList.remove('no-js');

const qs = (selector, root = document) => root.querySelector(selector);
const qsa = (selector, root = document) => [...root.querySelectorAll(selector)];

function setDrawer(name, open) {
  const drawer = qs(`[data-drawer="${name}"]`);
  const overlay = qs('[data-drawer-overlay]');
  if (!drawer) return;
  drawer.toggleAttribute('data-open', open);
  drawer.setAttribute('aria-hidden', String(!open));
  if (overlay) overlay.hidden = !open;
  document.body.classList.toggle('drawer-open', open);
}

document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-open-drawer]');
  const closer = event.target.closest('[data-close-drawer], [data-drawer-overlay]');
  if (opener) setDrawer(opener.dataset.openDrawer, true);
  if (closer) qsa('[data-drawer][data-open]').forEach((el) => setDrawer(el.dataset.drawer, false));
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') qsa('[data-drawer][data-open]').forEach((el) => setDrawer(el.dataset.drawer, false));
});

qsa('[data-quantity]').forEach((wrap) => {
  const input = qs('input', wrap);
  wrap.addEventListener('click', (event) => {
    const btn = event.target.closest('button');
    if (!btn || !input) return;
    const next = Math.max(Number(input.min || 1), Number(input.value || 1) + Number(btn.dataset.step));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
});

qsa('[data-sort-by]').forEach((select) => select.addEventListener('change', () => {
  const url = new URL(location.href);
  url.searchParams.set('sort_by', select.value);
  location.assign(url.toString());
}));

qsa('[data-product-gallery] button').forEach((button) => button.addEventListener('click', () => {
  const main = qs('[data-product-main-image]');
  if (main) { main.src = button.dataset.image; main.alt = button.dataset.alt || ''; }
}));

const brandSearch = qs('[data-brand-search]');
const brandCards = qsa('[data-brand-card]');
const brandEmpty = qs('[data-brand-empty]');
function filterBrands(value = '') {
  const query = value.trim().toLocaleLowerCase();
  let shown = 0;
  brandCards.forEach((card) => {
    const matches = !query || card.dataset.brandName.toLocaleLowerCase().includes(query);
    card.hidden = !matches;
    if (matches) shown += 1;
  });
  if (brandEmpty) brandEmpty.hidden = shown > 0;
}
if (brandSearch) brandSearch.addEventListener('input', (event) => filterBrands(event.target.value));
qsa('[data-brand-letter]').forEach((button) => button.addEventListener('click', () => {
  const letter = button.dataset.brandLetter;
  if (brandSearch) brandSearch.value = letter === 'ALL' ? '' : letter;
  brandCards.forEach((card) => {
    const matches = letter === 'ALL' || card.dataset.brandName.toLocaleUpperCase().startsWith(letter);
    card.hidden = !matches;
  });
  qsa('[data-brand-letter]').forEach((item) => item.toggleAttribute('data-active', item === button));
  if (brandEmpty) brandEmpty.hidden = brandCards.some((card) => !card.hidden);
}));
